import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

export default function RatingDialog({ open, onClose, onConfirm }) {
  const [rating, setRating] = useState(0);

  const handleStarClick = (index) => {
    setRating(index + 1);
  };

  useEffect(() => {
    if (!open) {
      setRating(0);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: 3,
          width: "100%",
          maxWidth: "360px", // 최대 너비 설정
        },
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "24px",
          backgroundColor: "#ffffff",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        <div style={{ height: "24px" }} />
        {/* 메세지만 있을경우 BOLD로 대체 */}

        <div className="f20_111827_W600">서비스는 만족하셨나요?</div>

        <div style={{ height: "16px" }} />
        {/* ✅ 별점 영역 */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              onClick={() => handleStarClick(i)}
              style={{
                cursor: "pointer",
                fontSize: "38px",
                color: i < rating ? "#FFD600" : "#E0E0E0", // 노란색 or 회색
                transition: "color 0.2s",
                margin: "0 4px",
              }}
            >
              ★
            </span>
          ))}
        </div>

        <div style={{ height: "32px" }} />

        <div
          onClick={() => onConfirm(rating)}
          className="f16_111827_W600"
          style={{
            display: "flex",
            width: "fit-content",
            textAlign: "center",
            borderRadius: "8px",
            backgroundColor: "#FFD600",
            padding: "12px 24px",
            cursor: "pointer",
          }}
        >
          제출하기
        </div>
        <div style={{ height: "24px" }} />
      </div>
    </Dialog>
  );
}
